module.exports = __webpack_public_path__ + "img/6.58c0f400.png";